import { HttpContextToken } from '@angular/common/http';

export const SKIP_SESSION_INVALIDATION = new HttpContextToken<boolean>(
  () => false,
);
